import React, {  Fragment, useState, useEffect } from 'react'
import {useHistory } from 'react-router-dom'
import {
    LogoutController,
    GetDataUser,
    cekVerifStatus,
    GetAuthCurrentUser,
    GetPhotoUrlFile
} from '../../Controller'
//template
import SideDrawer from '../Templates/SideDrawer'
import Activity from '../Templates/HomePageTemplate/Activity'
import VerificationModal from '../Templates/VerificationModal'
import MainContent from '../Templates/HomePageTemplate/MainContent'
//AssetTemplate
import userProfile from '../../Assets/Template/userProfile.png'
import SkelLoad from '../Templates/SkeletonLoading'
import '../../Css/HomePage.scss'


function HomePage(){
    
    const history = useHistory()
    const [_getAuthCurrentUser, set_getAuthCurrentUser] = useState(GetAuthCurrentUser())
    // const [user, setuser] = useState({})
    const [GetStats, setGetStats] = useState({})
    const [urlProfilePicture, seturlProfilePicture] = useState('')
    const [userDetail, setuserDetail] = useState({})
    const [Loading, setLoading] = useState(false)

    useEffect(() => {
        
        setLoading(true)
        if(!_getAuthCurrentUser){
            logout()
        }else{
           
           startSession()
        }
    },[])


    const startSession = () => {
        GetDataUser(_getAuthCurrentUser.uid)
        .then(res=>{
            // setuser(res)
            setGetStats(res.stats)
            setuserDetail(res.details)
            GetPhotoUrlFile(_getAuthCurrentUser.photoURL).then(res=>{
                seturlProfilePicture(res)
            }) 
            setLoading(false) 
                 
        })
    }
    
    const logout = () => {
        LogoutController().then(()=>{
             history.push('/')
        })
    }

    const SendEmailVerif = () => {
        cekVerifStatus(_getAuthCurrentUser).then(()=>{
            logout()
        })
    }

    
    return(
        
        <Fragment>
            {!_getAuthCurrentUser.emailVerified && 
                <VerificationModal
                    button = {SendEmailVerif}
                    buttonName = "Send Verification"
                    open = {true}
                    onClose = {logout}
                    headerMessage = "Send Email Verification"
                    bodyMessage = "Kirim emailnya kalo mau lanjut"

                /> 
            }
           
            <SideDrawer
                home={true}
            />
            <section className = "homePageBodyWrapper">
                <div className = "photoProfileWrapper">
                    <div>
                        {Loading == true ? <SkelLoad/> :  
                            <img src={_getAuthCurrentUser.photoURL ? urlProfilePicture : userProfile} alt=""/> 
                        }    
                    </div>
                </div>
                <div className = "userDetailWrapper">
                    <div>
                        <h4>
                            Role - {userDetail.role == 1 ? "AdminTeam" : "Activist"}
                        </h4>
                        <h3>
                            {Loading == true ? <SkelLoad/> : _getAuthCurrentUser.displayName }
                        </h3>
                        <Activity
                            status={GetStats}
                            loading = {Loading}
                        />
                    </div>
                   
                </div>
            </section>
            
            <MainContent/>
        </Fragment>
    )
}  
export default HomePage